import { GetTyreBrandsResponse } from "@/central-atoms/everest-fleet-pwa/responses";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type CheckInViaDriverDetails = {
  tyreBrands: GetTyreBrandsResponse | null
}

const initialState: CheckInViaDriverDetails = {
  tyreBrands: null
};

const checkInViaDriverDetailsSlice = createSlice({
  name: "checkInViaDriverDetails",
  initialState,
  reducers: {
    setTyreBrands: (state, action: PayloadAction<GetTyreBrandsResponse>) => {
      state.tyreBrands = action.payload;
    },
  },
});

export const { setTyreBrands } = checkInViaDriverDetailsSlice.actions;
export default checkInViaDriverDetailsSlice.reducer;
